import { render, staticRenderFns } from "./JobBookmarks.htm?vue&type=template&id=6f462051&"
import script from "./JobBookmarks.ts?vue&type=script&lang=js&"
export * from "./JobBookmarks.ts?vue&type=script&lang=js&"
import style0 from "../BookmarksTab.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports